import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import { MOCK_WORK_ORDER_PICTURES } from "../data";
import { useStyles } from "./styles";
import { usePictureUpload } from "./usePictureUpload";

const Pictures = () => {
  const { t } = useTranslation();
  const styles = useStyles();

  const { isDragActive, openFilePicker, fileInputRef, inputProps, dragDropProps } =
    usePictureUpload({
      onFilesSelected: () => {},
    });

  return (
    <Box className={styles.picturesSection} {...dragDropProps}>
      <input
        {...inputProps}
        ref={fileInputRef}
        className={styles.hiddenFileInput}
        aria-hidden
        tabIndex={-1}
      />

      <Box
        className={clsx(styles.dragHint, isDragActive && styles.dragHintActive)}
      >
        <Typography
          className={styles.dragHintText}
          onClick={openFilePicker}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              openFilePicker();
            }
          }}
        >
          {t("WORK_ORDER.PICTURES.DRAG_HINT")}
        </Typography>
      </Box>

      <Box className={styles.picturesGrid}>
        {MOCK_WORK_ORDER_PICTURES.map((picture) => (
          <Box key={picture.id} className={styles.pictureCard}>
            <Box className={styles.picturePreview}>
              <Box className={styles.picturePlaceholderIcon}>
                <ImageOutlinedIcon />
              </Box>
            </Box>

            <Box className={styles.pictureInfo}>
              <Box className={styles.pictureMeta}>
                <Typography className={styles.pictureFileName}>
                  {t(picture.fileNameKey)}
                </Typography>
                <Typography className={styles.pictureDate}>
                  {t(picture.dateKey)}
                </Typography>
              </Box>
              <Box className={styles.pictureAvatar}>{picture.uploaderInitials}</Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Pictures;
